import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {TaskService} from '../../../../services/task.service';
import { NzMessageService } from 'ng-zorro-antd/message';
@Component({
  selector: 'app-scan-audit-or-indicator-when-indicator-status',
  templateUrl: './scan-audit-or-indicator-when-indicator-status.component.html',
  styleUrls: ['../parts.css']
})
export class ScanAuditOrIndicatorWhenIndicatorStatusComponent implements OnInit {
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  indicatorStatus: string;
  indicatorStatusText = '何';
  indicatorStatusVisible = false;
  indicatorVisible = false;
  indicatorId: string;
  indicatorDisplayText = '监控项';
  indicatorData = [];
  auditData = [];
  indicatorStatusData = [];
  isConfirmLoading = false; // 确定按钮
  recipeId = null; // 自动化模板ID
  relationId = null;
  categorieId: string; // 存放当前目录ID
  instanceData: any = {}; // 存放实例返填数据
  backFillData: any;
  auditItemOrindicatorItemVisible = false;
  auditItemOrindicatorItemDisplayText = '稽核项/监控项';
  auditItemIdList = [];
  indicatorItemIdList = [];
  tabsIndex = 0;
  automation = {
    boardId: '',
    groupId: '',
    categoryId: '',
    relationId: '',
    indicatorItemId: '',
    indicatorExecutionStatus: '',
    instanceDescription: '',
    auditItemIdList: [],
    indicatorItemIdList: [],
    taskMapping: {}
  };
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService,
    private message: NzMessageService
  ) { }

  ngOnInit(): void {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
    this.getIndicatorItemsData();
    this.getAuditItemsData();
    this.indicatorStatusData = [
      {
        id: 'normal',
        name: '正常'
      },
      {
        id: 'abnormal',
        name: '异常'
      }
    ];
    // 处理返填数据
    if (this.instanceData && this.instanceData.config) {
      // 触发发射事件
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      this.backFillData = this.automation.taskMapping;
    }
    // 带入菜单ID
    this.indicatorId = this.automation.indicatorItemId;
    this.indicatorStatus = this.automation.indicatorExecutionStatus;
    this.indicatorItemIdList = this.automation.indicatorItemIdList;
    this.auditItemIdList = this.automation.auditItemIdList;
    if (this.indicatorItemIdList.length > 0) {
      this.auditItemOrindicatorItemDisplayText = '监控项';
    }
    if (this.auditItemIdList.length > 0) {
      this.auditItemOrindicatorItemDisplayText = '稽核项';
    }
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    this.indicatorStatusData.forEach(item => {
      if (item.id === this.indicatorStatus) {
        this.indicatorStatusText = item.name;
      }
    });
    this.packageData();
  }
  // 获取任务创建数据
  getTaskIntegrationData(event) {
    // this.backFillData = event;
    const obj: any = {};
    event.forEach((item, index) => {
      let mapObj: any;
      if (typeof item.mappingValue === 'string') {
        switch (item.type) {
          case 'dropdown':
            mapObj = {
              'fixedValue': {
                'ids': [item.mappingValue]
              }
            };
            break;
          case 'select':
            mapObj = {
              'fixedValue': {
                'option': item.mappingValue
              }
            };
            break;
          case 'button':
            mapObj = {
              'fixedValue': {
                'original': item.mappingValue
              }
            };
            break;
        }
      }
      if (item.type === 'dropdown' || item.type === 'select' || item.type === 'button') {
        obj[item.id] = mapObj;
      } else {
        const mpArr = [];
        item.mappingValue.forEach((m, i) => {
          mapObj = {
            'type': 'field',
            'sourceField': {
              'id': m.id,
              'type': m.type ? m.type : 'text',
              'title': m.title
            }
          };
          mpArr.push(mapObj);
        });
        mpArr.unshift({'type': 'text', 'text': item.mappingFirstValue});
        mpArr.push({'type': 'text', 'text': item.mappingEndValue});
        obj[item.id] = {
          'targetField': {
            'id': item.id,
            'title': item.title,
            'type': item.type,
          },
          'mappingParts': mpArr
        };
      }
      this.automation.taskMapping['mappingConfig'] = obj;
    });
    this.packageData();
  }
  // 组件提交数据
  packageData() {
    this.automation.instanceDescription = '当监听到' + this.indicatorDisplayText + '的状态为' + this.indicatorStatusText + '时，扫描' + this.auditItemOrindicatorItemDisplayText;
    this.nfDataChange.emit(this.automation);
  }
  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus(): boolean {
    const status = this.indicatorId && this.indicatorStatus && (this.auditItemIdList.length > 0 || this.indicatorItemIdList.length > 0) ? true : false;
    return status;
  }
  indicatorChange(item) {
    this.indicatorData.forEach(list => {
      if (list.id === item) {
        this.indicatorDisplayText = list.name;
      }
    });
    this.indicatorId = item;
    this.indicatorVisible = false;
    this.automation.indicatorItemId = this.indicatorId;
    this.packageData();
  }
  indicatorStatusChange(item) {
    this.indicatorStatusText = item.name;
    this.indicatorStatus = item.id;
    this.indicatorStatusVisible = false;
    this.automation.indicatorExecutionStatus = this.indicatorStatus;
    this.packageData();
  }
  // 获取监控列表
  getIndicatorItemsData() {
    this.taskService.getIndicatorItems().subscribe((res: any) => {
      this.indicatorData = res && res._embedded ? res._embedded.vos : [];
      if (this.indicatorData && this.indicatorData.length) {
        this.indicatorData.forEach(item => {
          if (item.id === this.indicatorId) {
            this.indicatorDisplayText = item.name;
          }
        });
      }
    });
  }
  // 获取稽核列表
  getAuditItemsData() {
    this.taskService.getAuditItems().subscribe((res: any) => {
      this.auditData = res && res._embedded ? res._embedded.vos : [];
    });
  }
  handleTreeData(data) {
    data.forEach(item => {
      item.title = item.name;
      if (item.children && item.children.length) {
        this.handleTreeData(item.children);
      } else {
        item.isLeaf = true;
      }
    });
    return data;
  }
  indicatorItemChange(event) {
    this.auditItemOrindicatorItemDisplayText = '监控项';
    if (this.indicatorItemIdList.length === 0 && this.auditItemIdList.length === 0) {
      this.auditItemOrindicatorItemDisplayText = '稽核项/监控项';
    }
    this.automation.indicatorItemIdList = this.indicatorItemIdList;
    this.packageData();
  }
  auditItemChange(event) {
    this.auditItemOrindicatorItemDisplayText = '稽核项';
    if (this.indicatorItemIdList.length === 0 && this.auditItemIdList.length === 0) {
      this.auditItemOrindicatorItemDisplayText = '稽核项/监控项';
    }
    this.automation.auditItemIdList = this.auditItemIdList;
    this.packageData();
  }
  tabsChange(event) {
    if (event === 0) {
      this.indicatorItemIdList = [];
    } else {
      this.auditItemIdList = [];
    }
    if (this.indicatorItemIdList.length === 0 && this.auditItemIdList.length === 0) {
      this.auditItemOrindicatorItemDisplayText = '稽核项/监控项';
    }
  }
}
